export default __webpack_public_path__ + "static/DataDogLogo-4229490d33187e255dc7aeb583046481.svg";